module.exports = "<p>\n  modal-kanban-reset-pin works!\n</p>\n"